/** SIRET lisible : « 314 559 675 00017 » (SIREN + NIC). */
export const fmtSiret = (s) => String(s || "").replace(/^(\d{3})(\d{3})(\d{3})(\d{5})$/, "$1 $2 $3 $4");

/** Même règle que le serveur (shared/company-directory) : 14 chiffres + clé de Luhn ; La Poste : somme multiple de 5. */
export const isValidSiret = (s) => {
  if (!/^\d{14}$/.test(s || "")) return false;
  const d = [...s].map(Number);
  if (d.reduce((sum, x, i) => sum + (i % 2 === 0 ? (x * 2 > 9 ? x * 2 - 9 : x * 2) : x), 0) % 10 === 0) return true;
  return s.startsWith("356000000") && d.reduce((a, b) => a + b, 0) % 5 === 0;
};
